module.exports = __webpack_public_path__ + "static/media/ic-shield.8d1f66e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ic-shield.svg
// module id = 151
// module chunks = 17